const Constants = require('graph-netecs/js/Constants').Constants;
const Value = require('graph/js/Value').Value;

export const measurementsAbstract = {
        lockValidation: false,
        unloadLock: false,
        unloadCount: 0,
        dataRounding: {
            workPointPerformance: 3,
            workPointPerformanceHour: 3,
            workPointTemperature: 0,
            workPointTemperatureCelsius: 0,
            workPointPressure: 3,
            workPointAboveSea: 0,
            workPointAirDensity: 4,
            workPointAmount: 5
        },

        initEvents() {
            $('#workPointAirDensity').on('change keyup', () => {
                this.workPointAirDensityTotal();
            });

            this.refreshAirDensity();
            this.refreshRotationSpeed();
            this.workPointAirDensityTotal();
        },
        /**
         * zaokrąglij dane zaladowane z inputów w this.data
         */
        rounding() {
            for (let name in this.dataRounding) {
                if (this.data[name]) {
                    this.data[name] = this.data[name].roundTo(this.dataRounding[name]);
                }
            }
        },
        /**
         * ładuej wszystkie dane z inputów do this.data
         * kluczem jest atrybut name inputa
         * inputy z data-type="number" są automatycznie parsowane
         * checkboxy są zamieniane na booleany
         * ignorowane są inputy zawierające klasę ignoreLoadData
         * jeśli nie ma jakeigoś inputa, to zmienna w this.data pozostaje bez zmian
         */
        loadData() {
            this.unloadCount = 0;

            if (!this.data.characteristic)
                this.data.characteristic = {};

            for (let parametersContainer in this.store.state.fourthStepParametersSelected) {
                let paramContainer = this.store.state.fourthStepParametersSelected[parametersContainer];

                if (paramContainer.hasOwnProperty("name") && paramContainer.hasOwnProperty("value")) {
                    if (paramContainer['name'] != '') {
                        this.data[paramContainer['name']] = Number.parse(paramContainer['value']);

                        if (paramContainer['name'] == "workPointPerformance") {
                            let valueHour = Number.parse(paramContainer['value']) * 3600;
                            this.data['workPointPerformanceHour'] = parseFloat(valueHour.format(window.unitsList.performance.default_decimal_places));
                        }

                        if (paramContainer['name'] == "workPointTemperature") {
                            let valueCelsius = Number.parse(paramContainer['value']) - 273.15;
                            this.data['workPointTemperatureCelsius'] = valueCelsius;
                        }
                    }
                }

                if (this.store.state.fourthStepParametersSelected.hasOwnProperty(parametersContainer)) {
                    for (let optionId in paramContainer['options']) {
                        let option = this.store.state.fourthStepParametersSelected[parametersContainer]['options'][optionId];

                        if (option.hasOwnProperty("name") && option.hasOwnProperty("type") && option['type'] == "radio") {
                            for (let elementId in option['elements']) {
                                let element = option['elements'][elementId];

                                if (element['active'] == true) {
                                    this.data[option['name']] = element['value'];
                                }
                            }
                        }
                    }
                }
            }
        },
        /**
         * dane z this.data ładuje spowrotem do inputów
         * kluczem jest atrybut name inputa
         * inputy z data-type="number" są automatycznie formatowane, z uwzględnieniem ilości miejsc po przecinku jeśli zadeklarowaliśmy w this.dataRounding
         * w checkboxach nie ruszamy value, tylkoustawiamy czy jest checked
         * w radiobuttonach zaznaczamy ten, którego value się zgadza
         * ignorujemy inputy, w których jesteśmy zfokusowani
         */
        unloadData(firstCalc = false) {
            if (this.store.state && this.graphsSummary && this.store.state.selectedWorkPoint && !this.store.state.selectedWorkPoint.locked) {
                this.store.state.selectedWorkPoint = {
                    locked: false,
                    workPointPressure: this.graphsSummary.data.workPointPressure,
                    workPointPerformance: this.graphsSummary.data.workPointPerformance,
                    workPointPerformanceHour: this.graphsSummary.data.workPointPerformanceHour,
                };
            }

            let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : 1);

            if (this.store.state.selectedFan) {
                // NVS-40 Problem wynikał z tego, że warunek sprawdzał czy moc na wale z materiałem jest większa od maksymalnej mocy silnika, a powinien brać moc zainstalowaną. Niektóre wentylatory miały od razu ten warunek nie spełniony w punkcie pracy.
                if (
                    (   // warunek 1
                        // jest spełniony gdy jest to pierwsze obliczenie LUB gdy przeciągamy punkt żądany
                        firstCalc || // pierwsze obliczenie
                        this.graphsSummary.dragEventElementType == "requestedPoint" || // przeciąganie punktu żądanego na graphSummary
                        this.graphsObj.dragEventElementType == "requestedPoint" // przeciąganie punktu żądanego
                    ) 
                    && 
                    (   // warunek 2
                        // jest spełniony gdy moc na wale z materiałem nie jest liczbą 
                        // LUB 
                        // moc na wale jest większa od maksymalnej mocy silnika przy zmiennej mocy
                        // LUB
                        // zagęszczenie materiału lub wydajność nie jest liczbą lub zagęszczenie jest większe od maksymalnego
                        (
                            (
                                isNaN(this.graphsObj.workPointResult['PowerOnShaftWithMaterial']) || // moc na wale z materiałem nie jest liczbą
                                (
                                    this.store.state.activeFun.selectedFanData.motor_power != "constant" // moc nie jest stała - parametr wentylatora
                                    && 
                                    (this.graphsObj.workPointResult['PowerOnShaftWithMaterial'] / _number_of_fans) > this.store.state.activeFun.params.installed_power // moc na wale z materiałem jest większa od mocy zainstalowanej

                                    // (this.graphsObj.workPointResult['PowerOnShaftWithMaterial'] / _number_of_fans) > this.store.state.activeFun.data.maximum_engine_power // NVS-40 BYŁO: moc na wale z materiałem jest większa od maksymalnej mocy silnika
                                )
                            )
                        ) 
                        ||
                        (
                            isNaN(this.graphsObj.data["workPointAmountUnit"]) || // zagęszczenie materiału nie jest liczbą
                            isNaN(this.graphsObj.workPointResult["Performance"]) || // wydajność nie jest liczbą
                            (Number.parse(this.graphsObj.data['workPointAmount']) / 3.6 / Number.parse((this.graphsObj.workPointResult["Performance"].oryginal / _number_of_fans))) > parseFloat(this.store.state.activeFun.selectedFanData.max_density) // zagęszczenie materiału jest większe niż maksymalne zagęszczenie wentylatora
                        )
                    ) 
                    &&
                    this.unloadLock == false // warunek 3 - spełniony gdy nie wykonuje się aktualnie operacja unload
                ) {

                    this.unloadLock = true;

                    if (firstCalc || this.graphsSummary.dragEventElementType == "requestedPoint") {
                        this.unloadCount++;

                        if (this.unloadCount < 5 && !firstCalc) {
                            this.graphsSummary._moveRequestedPointToStart();
                        }
                        else {
                            if ((this.unloadCount < 10 || firstCalc) && (this.graphsObj.workPointResult['PowerOnShaftWithMaterial'] / _number_of_fans) > this.store.state.activeFun.data.maximum_engine_power){
                                let workPointPerformance = Math.min(this.graphsObj.fan.lines.PowerOnShaftWithMaterial.getDataByY(this.store.state.activeFun.data.maximum_engine_power, this.data.range_min, this.data.range_max));
                                let workPointTotalPressure = this.graphsObj.fan.lines.TotalPressure.fun(workPointPerformance);

                                if(firstCalc && this.graphsObj.data.workPointPerformance > workPointPerformance) {
                                    this.graphsObj._moveRequestedPointToVeryFirstStart = () => {
                                        this.graphsObj.data.workPointPerformance = workPointPerformance;
                                        this.graphsObj.data.workPointPerformanceHour = workPointPerformance * 3600;
                                        this.graphsObj.data.workPointPressure = workPointTotalPressure;

                                        this.graphsObj.changed.call(this);
                                    };
                                }

                                this.graphsObj._moveRequestedPointToVeryFirstStart();
                            }
                            else {
                                this.graphsObj._moveRequestedPointToVeryFirstStart();
                            }
                        }
                    }

                    if (firstCalc || this.graphsObj.dragEventElementType == "requestedPoint") {
                        this.unloadCount++;

                        if (this.unloadCount < 5  && this.graphsSummary.dragEventElementType != "") {
                            this.graphsSummary._moveRequestedPointToStart();
                        }
                        else if (this.unloadCount < 10 && (this.graphsObj.workPointResult['PowerOnShaftWithMaterial'] / _number_of_fans) > this.store.state.activeFun.data.maximum_engine_power){
                            let workPointPerformance = Math.min(this.graphsObj.fan.lines.PowerOnShaftWithMaterial.getDataByY(this.store.state.activeFun.data.maximum_engine_power, this.data.range_min, this.data.range_max));
                            let workPointTotalPressure = this.graphsObj.fan.lines.TotalPressure.fun(workPointPerformance);

                            this.graphsSummary._moveRequestedPointTo(workPointPerformance, workPointPerformance * 3600, workPointTotalPressure);
                        }
                        else {
                            this.graphsObj._moveRequestedPointToVeryFirstStart();
                        }
                    }
                    return;
                } 
                // Ograniczenia przeciągania częstotliwości
                else if (this.graphsSummary.dragEventElementType == "frequency" || this.graphsObj.dragEventElementType == "frequency") {
                    let min_frequency = parseFloat(this.store.state.activeFun.selectedFanData.min_frequency);

                    if (this.graphsObj.data.workPointFrequency < min_frequency) {
                        this.graphsObj.data.workPointFrequency = min_frequency;
                        this.graphsObj.data.workPointRotationSpeed = this.graphsObj.data.workPointFrequency / Constants.frequency * this.graphsObj.data.engine_rpm;
                    }

                    let max_frequency = ((this.store.state.activeFun.selectedFanData.max_speed / this.graphsObj.data.engine_rpm) * 50);

                    if (this.graphsObj.data.workPointFrequency > max_frequency) {
                        this.graphsObj.data.workPointFrequency = max_frequency;
                        this.graphsObj.data.workPointRotationSpeed = this.graphsObj.data.workPointFrequency / Constants.frequency * this.graphsObj.data.engine_rpm;
                    }

                    if (this.store.state.activeFun.selectedFanData.motor_power != "constant") {
                        let selected_density = this.graphsObj.data.workPointAmountUnit / 1000;

                        if (this.store.state.selectedFirstStepElement.default_minimum_material_density == 1
                            && this.store.state.selectedFirstStepElement.default_minimum_material_density_value > this.graphsObj.data.workPointAmountUnit)
                            selected_density = this.store.state.selectedFirstStepElement.default_minimum_material_density_value / 1000;


                        let max_power_on_shaft = (this.store.state.activeFun.params.installed_power * (this.store.state.activeFun.data.engine_rpm == 3000 ? 1.07 : 1.03) * this.store.state.activeFun.engine.efficiency_3_4) / ((this.graphsObj.workPointResult.AirDensity + selected_density) / this.graphsObj.workPointResult.AirDensity);
                        let max_frequency2 = Math.pow(((max_power_on_shaft * Math.pow(this.graphsObj.workPointResult["Frequency"], 3)) / this.graphsObj.workPointResult["PowerOnShaft"]._oryginal), 1.0 / 3.0);

                        if (this.graphsObj.data.workPointFrequency > max_frequency2) {
                            this.graphsObj.data.workPointFrequency = max_frequency2;
                            this.graphsObj.data.workPointRotationSpeed = this.graphsObj.data.workPointFrequency / Constants.frequency * this.graphsObj.data.engine_rpm;
                        }
                    }
                }
                // NVS-92 Warunek opisujący ograniczenia przeciągania temperatury
                else if (this.graphsSummary.dragEventElementType == "temperature" || this.graphsObj.dragEventElementType == "temperature") {
                    /*
                    NVS-179 - zmiana temperatury z doboru na stałą
                    let atmosphericPressure = Constants.airPressure * Math.pow((1 - (6.5 * this.graphsObj.data.workPointAboveSea / 1000) / this.graphsObj.data.workPointTemperature), 5.256);
                    */

                    let atmosphericPressure = Constants.airPressure * Math.pow((1 - (6.5 * this.graphsObj.data.workPointAboveSea / 1000) / 288.15), 5.256);

                    let min_temperature = parseFloat(this.store.state.activeFun.selectedFanData.medium_temperature_from) + 273.15
                    let max_temperature = parseFloat(this.store.state.activeFun.selectedFanData.medium_temperature_to) + 273.15

                    let min_density = (3.468 * atmosphericPressure) / (1000 * max_temperature)
                    let max_density = (3.468 * atmosphericPressure) / (1000 * min_temperature)

                    let max_density_2 = (this.store.state.activeFun.params.installed_power * this.graphsObj.workPointResult.AirDensity) / this.graphsObj.workPointResult['PowerOnShaftWithMaterial']

                    if (max_density_2 < max_density) {
                        max_density = max_density_2
                        min_temperature = (3.468 * atmosphericPressure) / max_density / 1000
                    }
                    
                    if (this.graphsObj.data.workPointAirDensity < min_density) {
                        this.graphsObj.data.workPointAirDensity = min_density
                        this.graphsObj.data.workPointTemperature = max_temperature
                        this.store.state.fourthStepParameters.temperature.value = max_temperature;
                        this.store.state.fourthStepParametersSelected.temperature.value = max_temperature;
                        
                    }

                    if (this.graphsObj.data.workPointAirDensity > max_density) {
                        this.graphsObj.data.workPointAirDensity = max_density
                        this.graphsObj.data.workPointTemperature = min_temperature
                        this.store.state.fourthStepParameters.temperature.value = min_temperature;
                        this.store.state.fourthStepParametersSelected.temperature.value = min_temperature;
                    }
                }


                this.unloadLock = false;
                // NVS-190 - Dodanie "|| 0" żeby działało jak state.activeFun.count jest undefined
                let multippleValue = (this.store.state.activeFun.count || 0) < this.store.state.activeFun.data.number_of_fans ? this.store.state.activeFun.data.number_of_fans : 1;

                for (let workPointParamId in this.store.state.workPointParameters.elements) {
                    let workPointParam = this.store.state.workPointParameters.elements[workPointParamId];
                    if (workPointParam.workPointId != "") {
                        if (workPointParam.workPointId == "maximum_total_pressure")
                            workPointParam.value = this.getMultipliedValue(this.graphsObj.fan.lines.TotalPressure.fun(this.graphsObj.graphs.TotalPressure.minX), multippleValue, workPointParam.multippleByNumberOfFans);
                        else if (workPointParam.workPointId == "maximum_static_pressure")
                            workPointParam.value = this.getMultipliedValue(this.graphsObj.fan.lines.StaticPressure.fun(this.graphsObj.graphs.StaticPressure.minX), multippleValue, workPointParam.multippleByNumberOfFans);
                        else if (workPointParam.workPointId == "AirDensity")
                            workPointParam.value = this.getMultipliedValue(this.graphsObj.workPointResult[workPointParam.workPointId], multippleValue, workPointParam.multippleByNumberOfFans);

                        else if (workPointParam.workPointId.startsWith("?data?_")) {
                            if (workPointParam.workPointId.replace("?data?_", "") == "workPointAmountUnit") {//Wyliczamy wartość z przecięcia
                                workPointParam.value = this.getMultipliedValue(((Number.parse(this.graphsObj.data['workPointAmount']) / 3.6 / Number.parse(this.graphsObj.workPointResult["Performance"].oryginal)) / multippleValue / 1000), multippleValue, workPointParam.multippleByNumberOfFans);
                            } else if (workPointParam.workPointId.replace("?data?_", "") == "range_min")
                                workPointParam.value = this.getMultipliedValue((this.graphsObj.graphs.StaticPressure.minX / this.store.state.activeFun.data.number_of_fans), multippleValue, workPointParam.multippleByNumberOfFans);
                            else
                                workPointParam.value = this.getMultipliedValue(this.graphsObj.data[workPointParam.workPointId.replace("?data?_", "")], multippleValue, workPointParam.multippleByNumberOfFans);
                        } else if (this.isNumber(this.graphsObj.workPointResult[workPointParam.workPointId]))
                            workPointParam.value = this.getMultipliedValue(this.graphsObj.workPointResult[workPointParam.workPointId], multippleValue, workPointParam.multippleByNumberOfFans);
                        else
                            workPointParam.value = this.getMultipliedValue(this.graphsObj.workPointResult[workPointParam.workPointId].oryginal, multippleValue, workPointParam.multippleByNumberOfFans);

                        if (workPointParamId == "work_frequency") {
                            this.store.state.fourthStepParametersSelected.workPointFrequency.value = workPointParam.value;
                        }
                    }
                }
            }

            if (this.store.state.fansTableData && this.store.state.fansTableData.FanTableRef && this.store.state.fansTableData.FanTableRef.allFilteredData.length > 0) {
                for (let axis in this.graphsSummary.graph._axis) {
                    this.loadUnitsSettings(axis, this.graphsSummary.graph._axis[axis].config.unit.id);
                }

                for (let axis of this.graphsSummary.graph.graph._xs) {
                    this.loadUnitsSettings(axis.config.unit.type, axis.config.unit.id);
                }

                if (this.graphsSummary.graph.graph && this.graphsSummary.graph.graph._gridXAxis)
                    this.loadUnitsSettings(this.graphsSummary.graph.graph._gridXAxis.config.unit.type, this.graphsSummary.graph.graph._gridXAxis.config.unit.id);
            }
        },

        getMultipliedValue(value, multiplieValue, shouldMultiply) {
            if (shouldMultiply)
                return value * multiplieValue;
            else
                return value;
        },

        loadUnitsSettings(typeName, unitId) {
            if (this.store.state.ValueUnitMap.hasOwnProperty(typeName)) {
                let parameters = {
                    type: 'setSelectedUnit',
                    paramId: typeName,
                    unitType: typeName,
                    unitId: unitId
                };

                this.store.commit(parameters);
            }
        }
        ,

        refreshAllData(frequency) {
            this.refreshWorkPointBaseFrequency(frequency);
            this.refreshAmount();
            this.refreshRotationSpeed();
            this.refreshFrequency();
            this.refreshAmountUnit();
            this.workPointAirDensityTotal();
            this.refreshAirDensity();
        }
        ,

        refreshWorkPointBaseFrequency(valueFrequency) {
            this.data.workPointFrequency = valueFrequency;
        }
        ,

        /**
         * wylicza ilość materiału na podstawie zagęszczenia i wydajności
         */
        refreshAmount() {
            this.data.workPointAmount = Number.parse(this.store.state.fourthStepParametersSelected['material_density'].value) * 3.6 * Number.parse(this.store.state.fourthStepParametersSelected['performance'].value);
            this.store.state.fourthStepParametersSelected['material_amount'].value = this.data.workPointAmount.format(window.unitsList.materialAmount.default_decimal_places);
            this.workPointAirDensityTotal();

            return {"workPointAmount": this.data.workPointAmount.format(window.unitsList.materialAmount.default_decimal_places)};
        }
        ,
        /**
         * wylicza obroty wirnika na pdostawie częstotliwości i obrotów silnika
         */
        refreshRotationSpeed() {
            this.data.workPointFrequency = Number.parse(this.store.state.fourthStepParametersSelected.workPointFrequency.value); //TODO: zmienić to
            this.data.workPointRotationSpeed = Number.parse(this.store.state.fourthStepParametersSelected.workPointFrequency.value) / Constants.frequency * this.data.engine_rpm; //TODO: zmienić to
            this.store.state.fourthStepParametersSelected.workPointRotationSpeed.value = (this.data.workPointRotationSpeed.format(window.unitsList.rotationSpeed.default_decimal_places));//TODO: zmienić to

            return {"workPointRotationSpeed": (this.data.workPointRotationSpeed.format(window.unitsList.rotationSpeed.default_decimal_places))};
        }
        ,
        /**
         * wylicza czestotliwość na pdostawie obrotów wirnika i obrotów silnika
         */
        refreshFrequency() {
            this.data.workPointFrequency = Number.parse(this.store.state.fourthStepParametersSelected.workPointRotationSpeed.value) / this.data.engine_rpm * Constants.frequency;
            this.store.state.fourthStepParametersSelected.workPointFrequency.value = this.data.workPointFrequency.format(window.unitsList.frequency.default_decimal_places);

            return {"workPointFrequency": (this.data.workPointRotationSpeed.format(this.data.workPointFrequency.format(window.unitsList.frequency.default_decimal_places)))};
        }
        ,
        /**
         * oblicza zagęszczenie materiału na pdostawie ilości materiału i wydajności rzadanej
         */
        refreshAmountUnit() {
            if (Number.parse(this.store.state.fourthStepParametersSelected['performance'].value))
                this.data.workPointAmountUnit = Number.parse(this.store.state.fourthStepParametersSelected['material_amount'].value) / 3.6 / Number.parse(this.store.state.fourthStepParametersSelected['performance'].value);

            let payload = {
                type: 'getActiveElementOfParamOption',
                option: this.store.state.fourthStepParametersSelected['material_density'].options[0],
                out: 0
            };

            this.store.commit(payload);

            let materialAmountDefaultDecimalPlaces = 0;

            if (payload.out && payload.out.unit && payload.out.unit.decimal_places)
                materialAmountDefaultDecimalPlaces = payload.out.unit.decimal_places;

            let workPointAmountUnitFormated = this.data.workPointAmountUnit.format(parseInt(materialAmountDefaultDecimalPlaces));

            if (workPointAmountUnitFormated)
                workPointAmountUnitFormated = workPointAmountUnitFormated.replace(',', '.');
            this.store.state.fourthStepParametersSelected['material_density'].value = isFinite(workPointAmountUnitFormated) ? workPointAmountUnitFormated : 0;
            this.workPointAirDensityTotal();
            return {"workPointAmountUnit": this.store.state.fourthStepParametersSelected['material_density'].value};
        }
        ,
        /**
         * wylicza gęstość powietrza z materiałem
         */
        workPointAirDensityTotal() {
            let workPointAirDensityTotal = this.data.workPointAirDensity + this.data.workPointAmountUnit / 1000;
            workPointAirDensityTotal = workPointAirDensityTotal.format(this.firstOrDefaulDecimalPlaces(window.unitsList.density));

            this.data.workPointAirDensityTotal = parseFloat(workPointAirDensityTotal.replace(",", "."));
            this.store.state.fourthStepParametersSelected['workPointAirDensityTotal'].value = isFinite(this.data.workPointAirDensityTotal) ? this.data.workPointAirDensityTotal : 0;
        }
        ,
        /**
         * wylicza gęstość powietrza
         */
        refreshAirDensity(setData = true) {
            this.loadData();
            let airDensity = this.data.calcAirDensity();
            let workPointAirDensityCalced = this.store.state.fourthStepParametersSelected.workPointAirDensityCalced;//TODO: zmienić
            let workPointAirDensity = this.store.state.fourthStepParametersSelected.workPointAirDensity;//TODO: zmienić
            if (workPointAirDensityCalced.value != airDensity.format() && !isNaN(airDensity)) {
                workPointAirDensity.value = airDensity.format(this.firstOrDefaulDecimalPlaces(window.unitsList.density));

                if (setData)
                    this.data.workPointAirDensity = airDensity;
            }
            workPointAirDensityCalced.value = airDensity.format(this.firstOrDefaulDecimalPlaces(window.unitsList.density));

            if (setData)
                this.data.workPointAirDensityCalced = airDensity;
        }
        ,
        /**
         * wyświetla wyniki w zakładce punkt pracy
         */
        setWorkPointResults: function () {
            for (let field in this.graphsObj.workPointResult) {
                let element = document.querySelector('#wpResult' + field);
                let elementUnit = document.querySelector('[data-wp-result-unit="' + field + '"]');

                if (element) {
                    let unit = null;
                    let displayString = "";
                    let value = this.graphsObj.workPointResult[field];

                    if (value instanceof Value) {
                        displayString = value.displayString;
                        unit = value.unit;
                        value = value.display;
                    } else if (typeof value == "number") {
                        displayString = value;
                        value = value;
                    }

                    if (isFinite(value))
                        element.textContent = this.formatWorkPointResultsValue(value, unit, displayString);
                    else
                        element.textContent = '-';
                }

                if (this.graphsObj.workPointResult[field].unit && elementUnit) {
                    elementUnit.innerHTML = this.graphsObj.workPointResult[field].unit.designation;
                }
            }
        },
        formatWorkPointResultsValue(value, unit, displayString) {
            if (unit && unit.name == "Kilowat" && value < 1) {
                return value.format(2);
            } else {
                return displayString;
            }
        },
        firstOrDefaulDecimalPlaces(unit) {
            if (unit) {
                if (unit.list && unit.list.length > 0 && unit.list[0].decimal_places) {
                    return unit.list[0].decimal_places;
                } else {
                    return unit.default_decimal_places;
                }
            } else {
                return null;
            }
        },
        isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
    }
;